import styled from 'styled-components';

import { Card } from '@xing-com/card';
import { GridContainer } from '@xing-com/grid';
import {
  spaceS,
  spaceXL,
  xdlColorBackgroundTertiary,
  xdlPalettePetrol01,
  xdlPaletteMint11,
  xdlColorPremiumSecondary,
} from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

import { type ProductBenefitsProps } from './product-benefits';

export const StyledBenefitsGridContainer = styled(GridContainer)`
  gap: ${spaceXL};
`;

export const StyledCard = styled(Card)<ProductBenefitsProps>`
  justify-content: flex-start;
  border-color: transparent;
  height: 100%;
  width: 100%;
  background: ${(props) =>
    props.product === 'projobs'
      ? xdlColorBackgroundTertiary
      : xdlPalettePetrol01};
`;

export const StyledIconPadding = styled.div<ProductBenefitsProps>`
  padding-bottom: ${spaceS};
  color: ${(props) =>
    props.product === 'projobs' ? xdlPaletteMint11 : xdlColorPremiumSecondary};
`;

export const StyledHeadline = styled(Headline)<{ product: string }>`
  padding-bottom: ${spaceXL};
  color: ${(props) =>
    props.product === 'projobs' ? xdlPaletteMint11 : xdlColorPremiumSecondary};
`;

export const StyledBodyCopy = styled(BodyCopy)<{ product: string }>`
  color: ${(props) =>
    props.product === 'projobs' ? xdlPaletteMint11 : xdlColorPremiumSecondary};
`;
